export default "__VITE_ASSET__k2sS15QK__"